import { CombinedState, createSelector } from '@reduxjs/toolkit';
import { RootStateType } from 'App/store';
import { InterfaceNuvemEnvioOrdersSchema } from '../ordersSlice';

export const getNuvemEnvioOrdersState = (
  state: RootStateType,
): CombinedState<InterfaceNuvemEnvioOrdersSchema> => state.nuvemEnvioOrders;

export const getNuvemEnvioLabelsData = createSelector(
  getNuvemEnvioOrdersState,
  (nuvemEnvioOrderState) => nuvemEnvioOrderState.createNuvemEnvioLabels.data,
);

export const getNuvemEnvioLabelsStatus = createSelector(
  getNuvemEnvioOrdersState,
  (nuvemEnvioOrderState) => ({
    isIdle: nuvemEnvioOrderState.createNuvemEnvioLabels.status === 'idle',
    isLoading: nuvemEnvioOrderState.createNuvemEnvioLabels.status === 'loading',
    isError: nuvemEnvioOrderState.createNuvemEnvioLabels.status === 'error',
    isSuccess: nuvemEnvioOrderState.createNuvemEnvioLabels.status === 'success',
  }),
);

export const getNuvemEnvioSimulateLabelsData = createSelector(
  getNuvemEnvioOrdersState,
  (nuvemEnvioOrderState) => nuvemEnvioOrderState.simulateNuvemEnvioLabels.data,
);

export const getNuvemEnvioSimulateLabelsStatus = createSelector(
  getNuvemEnvioOrdersState,
  (nuvemEnvioOrderState) => ({
    isIdle: nuvemEnvioOrderState.simulateNuvemEnvioLabels.status === 'idle',
    isLoading:
      nuvemEnvioOrderState.simulateNuvemEnvioLabels.status === 'loading',
    isError: nuvemEnvioOrderState.simulateNuvemEnvioLabels.status === 'error',
    isSuccess:
      nuvemEnvioOrderState.simulateNuvemEnvioLabels.status === 'success',
  }),
);

export const getNuvemEnvioCreditRechargeLabelsData = createSelector(
  getNuvemEnvioOrdersState,
  (nuvemEnvioOrderState) =>
    nuvemEnvioOrderState.creditRechargeNuvemEnvioLabels.data,
);

export const getNuvemEnvioCreditRechargeLabelsStatus = createSelector(
  getNuvemEnvioOrdersState,
  (nuvemEnvioOrderState) => ({
    isIdle:
      nuvemEnvioOrderState.creditRechargeNuvemEnvioLabels.status === 'idle',
    isLoading:
      nuvemEnvioOrderState.creditRechargeNuvemEnvioLabels.status === 'loading',
    isError:
      nuvemEnvioOrderState.creditRechargeNuvemEnvioLabels.status === 'error',
    isSuccess:
      nuvemEnvioOrderState.creditRechargeNuvemEnvioLabels.status === 'success',
  }),
);
